import { useState } from "react";
import Navbar from "../components/Navbar";
import api from "../api";

export default function DumpUpload() {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) {
      setMessage("Please select a dump file first.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await api.post("/housing/upload-dump/", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setMessage(res.data.message || "Dump uploaded successfully!");
      setFile(null);
    } catch (err) {
      console.error(err);
      setMessage(err.response?.data?.error || "Upload failed");
    }
  };

  return (
    <div className="min-h-screen">
      <Navbar />
      <div className="p-6 max-w-md mx-auto">
        <h1 className="text-2xl font-bold mb-4">Upload PostgreSQL Dump</h1>

        <input
          type="file"
          accept=".dump"
          onChange={handleFileChange}
          className="border p-2 rounded mb-4 w-full"
        />
        <button
          onClick={handleUpload}
          className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded"
        >
          Upload
        </button>

        {message && <p className="mt-4 text-gray-700">{message}</p>}
      </div>
    </div>
  );
}
